import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./style.css";
import { useStaggerReveal } from "../animation/scrollReveal";

const Experience = () => {
  const containerRef = useStaggerReveal(".vertical-timeline-element", {
    alternateX: true,
    duration: 0.9,
    start: "top 88%",
  });

  return (
    <>
      <div
        style={{
          textAlign: "center",
          marginBottom: 30
        }}
        className="header"
      >
        <i className="fa fa-briefcase title-icon" />
        EXPERIENCE
      </div>
      <div className="page" ref={containerRef}>
        <VerticalTimeline lineColor="linear-gradient(180deg, var(--primary-color), var(--secondary-color))">
          {experienceData.map((v, k) => (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                background: "#ffffff",
                color: "var(--text-primary)",
                border: "1px solid var(--card-border)",
                borderRadius: "var(--radius)",
                boxShadow: "6px 6px 0px var(--bg-dark)"
              }}
              contentArrowStyle={{ borderRight: "7px solid var(--bg-dark)" }}
              date={v.duration}
              dateClassName="timeline-date"
              iconStyle={{
                background: "var(--primary-color)",
                color: "#ffffff",
                boxShadow: "4px 4px 0px var(--bg-dark)"
              }}
              icon={<BriefcaseIcon />}
              key={k}
            >
              <div className="vertical-timeline-element-title title" style={{ fontSize: "20px", marginBottom: "8px" }}>
                {v.position}
              </div>
              <span className="vertical-timeline-element-subtitle subtitle" style={{ color: "var(--primary-color)", fontWeight: 600 }}>
                {v.company}
              </span>
              <p className="text-thin" style={{ marginTop: "12px" }}>{v.detail}</p>
              {v.technologies && (
                <div style={{ marginTop: "12px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {v.technologies.map((tech, index) => (
                    <span
                      key={index}
                      style={{
                        background: "var(--highlight-color)",
                        color: "var(--secondary-color)",
                        padding: "4px 12px",
                        borderRadius: "var(--radius)",
                        fontSize: "12px",
                        border: "1px solid var(--primary-color)",
                        fontWeight: 600
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              )}
            </VerticalTimelineElement>
          ))}
          {/* <VerticalTimelineElement
            iconStyle={{
              background: "linear-gradient(135deg, var(--accent-color), var(--secondary-color))",
              color: "var(--text-primary)",
              boxShadow: "0 0 20px var(--glow-color)"
            }}
            icon={
              <i
                className="fa fa-star fa-2x timeline-icon"
                style={{ marginTop: "22%", marginLeft: "20%" }}
              />
            }
          /> */}
        </VerticalTimeline>
      </div>
    </>
  );
};

export default Experience;

const BriefcaseIcon = () => {
  return (
    <i
      className="fa fa-briefcase fa-2x timeline-icon"
      style={{ marginTop: "24%", marginLeft: "24%", color: "var(--text-light)" }}
    />
  );
};

const experienceData = [
  {
    duration: "June 2025 - Present",
    position: "Full-Stack Developer (Full-time)",
    company: "Issara Institute",
    detail:
      "Developing and maintaining web applications using React, Python, and Django framework. Building scalable RESTful APIs, implementing responsive front-end interfaces, and managing database operations. Collaborating with cross-functional teams to deliver high-quality solutions.",
    technologies: ["React", "Python", "Django", "REST API", "PostgreSQL", "Git", "AWS"]
  },
  {
    duration: "2023 - 2025",
    position: "Full-Stack Engineer (Full-time Remote)",
    company: "Viatick - Singapore",
    detail:
      "Worked as a full-stack engineer developing projects like Feedback data analysis, VMS (Visitor Management System), and Cleaning App. Developed visualized API data through analytic dashboards, maintained chatbot platform and automated QR survey system. Implemented client feedback score mechanisms across application and web platforms, and real-time device alert monitoring systems.",
    technologies: ["React", "Node.js", "JavaScript", "Analytics Dashboard", "IoT", "Real-time Monitoring"]
  },
  {
    duration: "2019 - 2022",
    position: "Team Lead Developer (Full-time)",
    company: "KUMO Solutions (EverComm Singapore)",
    detail:
      "Led development team analyzing project workflows and data structures. Developed categorized questionnaire pages with various input types, generated visualized reports and monitoring dashboards from IoT raw data. Implemented scheduled calculated API for carbon emissions, baseline metrics and reduction measurements. Configured Apache server and orchestrated live server hosting.",
    technologies: ["React", "Node.js", "IoT", "Apache", "Data Visualization", "API Development"]
  },
  {
    duration: "2018 - 2019",
    position: "Software Service Technician (Part-time)",
    company: "Marter Solutions",
    detail:
      "Specialized in support and maintenance of Windows application software. Utilized C# and HTML for software development and troubleshooting. Conducted routine maintenance and provided support for SQL data servers to ensure efficient record management.",
    technologies: ["C#", "HTML", "SQL Server", "Windows Applications"]
  },
  {
    duration: "2017 - 2018",
    position: "Internship Developer (Freelance)",
    company: "IBCT Institute",
    detail:
      "Developed a static web project 'Eco Driving Cars' using HTML, CSS, PHP, JavaScript, and Microsoft SQL. Created a comprehensive student management system using C# for efficient administration.",
    technologies: ["HTML", "CSS", "PHP", "JavaScript", "C#", "Microsoft SQL"]
  },
  {
    duration: "2016 - 2017",
    position: "Student Team Lead",
    company: "Academic Project",
    detail:
      "Designed and developed a static website project called 'YOGA' using HTML, CSS, and jQuery to create an enhanced user experience.",
    technologies: ["HTML", "CSS", "jQuery"]
  }
];
